import React, { useEffect, useState } from 'react';
import {
    IOneplaceLibraryContextProp,
    withOneplaceLibraryContext,
    ValidationErrors,
    utils,
} from 'oneplace-components';
import { Api } from '../../data_sources/api';
import { IncidentSubmissionDialog, IncidentSubmissionStatus } from './IncidentSubmissionDialog';
import { IIncidentV2 } from '../../models/Incident';
import { fixChecklistData } from '../checklists/utils/submitChecklist';


export interface IIncidentFooterProps
    extends IOneplaceLibraryContextProp {
    incident: IIncidentV2
    errorsShown: boolean;
    errors: string[];
    onErrorsDismissed: () => void;
    onCloseSubmitDialog: () => void;
    isSubmitDialogOpen: boolean;
    region: string;
    path: string;
    onSubmitDialogsCompleted: () => void;
}

const IncidentFooterFn: React.FC<IIncidentFooterProps> = (props) => {

    const [submitDialogContent, setSubmitDialogContent] = useState<string | React.ReactElement<any>>('')
    const [submissionStatus, setSubmissionStatus] = useState<IncidentSubmissionStatus>(null)

    // set default content
    useEffect(() => {
        if (props.isSubmitDialogOpen && !submissionStatus && submitDialogContent === '') {
            setSubmitDialogContent(`Confirm submitting ${props.ctx.i18next.t('customLabel_incident')}?`)
        }
    }, [props.isSubmitDialogOpen, submissionStatus, submitDialogContent, props.ctx.i18next])

    function onCloseSubmitDialog() {
        if (submissionStatus === 'submitting') {
            return;
        }

        props.onCloseSubmitDialog()
        if (submissionStatus === 'success') {
            props.onSubmitDialogsCompleted()
        }
        setSubmitDialogContent('')
        setSubmissionStatus(null)
    }

    function onConfirmSubmitDialog(emails: string) {
        if (!submissionStatus) {

            setSubmissionStatus('submitting')
            submitIncidentV2(emails)
        } else {
            onCloseSubmitDialog()
        }
    }

    const submitIncidentV2 = async (emails: string) => {
        try {
            const region = props.region
            const path = props.path
            const api = new Api(region, path)

            // copy the incident and fix the data before submitting
            const incidentV2Data = utils.deepCopy(props.incident);
            fixChecklistData(incidentV2Data);

            const payload = {
                ...incidentV2Data,
                emails
            }
            await api.submitIncidentSign(payload)
            setSubmissionStatus('success')
            setSubmitDialogContent(`${props.ctx.i18next.t('customLabel_incident')} submitted successfully!`)
        } catch (e) {
            setSubmissionStatus('error')
            setSubmitDialogContent(`${e}`)
        }
    }

    return (
        <>
            <ValidationErrors
                errorsShown={props.errorsShown}
                errors={props.errors}
                onErrorsDismissed={props.onErrorsDismissed}
            />
            <IncidentSubmissionDialog
                isOpen={props.isSubmitDialogOpen}
                status={submissionStatus}
                content={submitDialogContent}
                onClose={() => onCloseSubmitDialog()}
                onConfirm={onConfirmSubmitDialog}
            />
        </>
    )

};

export const IncidentV2Footer = withOneplaceLibraryContext(IncidentFooterFn);
